import { createSlice } from "@reduxjs/toolkit";
import {
  getDocs,
  where,
  updateDoc,
  query,
  arrayUnion,
} from "firebase/firestore/lite";
import { userData } from "../firebase.config";

const initialState = {
  productData: [],
  userInfo: null,
};



export const shopSlice = createSlice({
  name: "shopsy",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.productData.push(action.payload);
      }


      // Add Cart to Firestore
      if (state.userInfo && state.userInfo._id) {
        console.log("uid", state.userInfo._id);
        console.log("item", action.payload);

        const prodId = action.payload._id;
        const prodTitle = action.payload.title;
        const prodImage = action.payload.image;
        const prodPrice = action.payload.price;

        const userId = state.userInfo._id;
        const product = { 
            productId: prodId,
            title: prodTitle,
            image: prodImage,
            price: prodPrice,
            quantity: 1,
         };

         const addToUserCart = async (userId, newItem) => {
          try {
            // Get the user document that matches the uid field
            const snapshot = await getDocs(
              query(userData, where("uid", "==", userId))
            );
        
            // Check if there is a matching document
            if (!snapshot.empty) {
              // Get the first matching document
              const doc = snapshot.docs[0];
        
              // Get the current cart from the document data
              const currentCart = doc.data().cart || [];
        
              // Find the index of the existing item in the cart
              const existingItemIndex = currentCart.findIndex(
                (item) => item && item.productId === newItem.productId
              ); 
        
              if (existingItemIndex === -1) {
                // Item not found, add new item to cart
                updateDoc(doc.ref, { cart: arrayUnion(newItem) });
              } else {
                // Item already exists, update its quantity
                const updatedCart = currentCart.slice(); // Make a copy of the cart array
                updatedCart[existingItemIndex].quantity += newItem.quantity; // Update the quantity of the existing item
                updateDoc(doc.ref, { cart: updatedCart });
              }
        
              console.log(
                `Item ${newItem.productId} added to cart for user ${userId}`
              );
            } else {
              console.log(`No user found with id ${userId}`);
            }
          } catch (error) {
            console.error(
              `Error adding item ${newItem.productId} to cart for user ${userId}:`,
              error
            );
          }
        };
        

        
        /* const addToUserCart = async (userId, newItem) => {
          try {
            // Get the user document that matches the uid field
            const snapshot = await getDocs(
              query(userData, where("uid", "==", userId))
            );
            console.log("qr", snapshot);

            // Loop through the matching documents and update the field
            snapshot.forEach((doc) => {
              const currentCart = doc.data().cart;
              const existingItemIndex = currentCart.findIndex(
                (item) => console.log("i",item) & item.productId? item.productId: "0" === newItem.productId
              );
              if (existingItemIndex === -1) {
                // Item not found, add new item to cart
                updateDoc(doc.ref, { cart: arrayUnion(newItem) });
              } else {
                // Item already exists, update its quantity
                const updatedCart = currentCart.slice(); // Make a copy of the cart array
                updatedCart[existingItemIndex].quantity += newItem.quantity; // Update the quantity of the existing item
                updateDoc(doc.ref, { cart: updatedCart });
              }
            });

            console.log(
              `Item ${newItem.productId} added to cart for user ${userId}`
            );
          } catch (error) {
            console.error(
              `Error adding item ${newItem.productId} to cart for user ${userId}:`,
              error
            );
          }
        }; */
        addToUserCart(userId, product);
      }
    },
    deleteItem: (state, action) => {
      state.productData = state.productData.filter(
        (item) => item._id !== action.payload
      );
      const userId = state.userInfo._id;
      const prodId = action.payload._id;
      console.log("delID ",prodId);

      const removeItemFromUserCart = async (userId, productId) => {
        try {
          // Get the user document that matches the uid field
          const snapshot = await getDocs(
            query(userData, where("uid", "==", userId))
          );
      
          // Check if there is a matching document
          if (!snapshot.empty) {
            // Get the first matching document
            const doc = snapshot.docs[0];
      
            // Get the current cart from the document data
            const currentCart = doc.data().cart || [];
      
            // Find the index of the item to remove in the cart
            const itemIndex = currentCart.findIndex(
              (item) => item.productId === productId
            );
      
            if (itemIndex !== -1) {
              // Item found, remove it from cart
              const updatedCart = currentCart.filter(
                (item, index) => index !== itemIndex
              );
              updateDoc(doc.ref, { cart: updatedCart });
      
              console.log(
                `Item ${productId} removed from cart for user ${userId}`
              );
            } else {
              console.log(`Item ${productId} not found in cart for user ${userId}`);
            }
          } else {
            console.log(`No user found with id ${userId}`);
          }
        } catch (error) {
          console.error(
            `Error removing item ${productId} from cart for user ${userId}:`,
            error
          );
        }
      };
      
      removeItemFromUserCart(userId,prodId)

    },
    resetCart: (state) => {
      state.productData = [];
    },
    increaseQty: (state, action) => {
       state.productData.find(
        (item) => item._id === action.payload._id
      );
      /* if (item.quantity === 9) {
        item.quantity = 9;
      } else {
        item.quantity++;
      } */

      const userId = state.userInfo._id;
      const prodId = action.payload._id;

      const increaseCartItemQuantity = async (userId, productId) => {
        try {
          const snapshot = await getDocs(query(userData, where("uid", "==", userId)));
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            const currentCart = doc.data().cart || [];
            const itemIndex = currentCart.findIndex(
              (item) => item.productId === productId
            );
            if (itemIndex !== -1) {
              const updatedCart = currentCart.slice();
              if (updatedCart[itemIndex].quantity < 8) {
                updatedCart[itemIndex].quantity += 1;
                await updateDoc(doc.ref, { cart: updatedCart });
                console.log(`Quantity increased for item ${productId}`);
              } else {
                console.log(`Quantity cannot be increased for item ${productId}, maximum quantity reached`);
              }
            } else {
              console.log(`Item ${productId} not found in cart for user ${userId}`);
            }
          } else {
            console.log(`No user found with id ${userId}`);
          }
        } catch (error) {
          console.error(`Error increasing quantity for item ${productId} for user ${userId}:`, error);
        }
      };
      

      increaseCartItemQuantity(userId,prodId)

    },
    decreaseQty: (state, action) => {
      state.productData.find(
        (item) => item._id === action.payload._id
        

      );
       
      const userId = state.userInfo._id;
      const prodId = action.payload._id;

      /* const decreaseCartItemQuantity = async (userId, productId) => {
        try {
          // Get the user document that matches the uid field
          const snapshot = await getDocs(
            query(userData, where("uid", "==", userId))
          );
      
          // Check if there is a matching document
          if (!snapshot.empty) {
            // Get the first matching document
            const doc = snapshot.docs[0];
      
            // Get the current cart from the document data, or initialize it to an empty array if it's not defined
            const currentCart = doc.data().cart || [];
      
            // Find the index of the existing item in the cart
            const existingItemIndex = currentCart.findIndex(
              (item) => item.productId === productId
            );
      
            if (existingItemIndex !== -1) {
              // Item found, decrease its quantity
              const updatedCart = currentCart.slice(); // Make a copy of the cart array
              updatedCart[existingItemIndex].quantity -= 1; // Decrease the quantity of the existing item
      
              if (updatedCart[existingItemIndex].quantity === 0) {
                // If the quantity of the item has reached 0, remove it from the cart
                updatedCart.splice(existingItemIndex, 1);
              }
      
              updateDoc(doc.ref, { cart: updatedCart });
      
              console.log(
                `Quantity of item ${productId} decreased for user ${userId}`
              );
            } else {
              // Item not found in cart
              console.log(`Item ${productId} not found in cart for user ${userId}`);
            }
          } else {
            // User document not found
            console.log(`No user found with id ${userId}`);
          }
        } catch (error) {
          console.error(
            `Error decreasing quantity of item ${productId} for user ${userId}:`,
            error
          );
        }
      }; */

      const decreaseCartItemQuantity = async (userId, productId) => {
        try {
          const snapshot = await getDocs(query(userData, where("uid", "==", userId)));
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            const currentCart = doc.data().cart || [];
            const itemIndex = currentCart.findIndex(
              (item) => item.productId === productId
            );
            if (itemIndex !== -1) {
              const updatedCart = currentCart.slice();
              if (updatedCart[itemIndex].quantity > 1) {
                updatedCart[itemIndex].quantity -= 1;
                await updateDoc(doc.ref, { cart: updatedCart });
                console.log(`Quantity decreased for item ${productId}`);
              } else {
                console.log(`Quantity cannot be decreased for item ${productId}, minimum quantity reached`);
              }
            } else {
              console.log(`Item ${productId} not found in cart for user ${userId}`);
            }
          } else {
            console.log(`No user found with id ${userId}`);
          }
        } catch (error) {
          console.error(`Error decreasing quantity for item ${productId} for user ${userId}:`, error);
        }
      };
      

      decreaseCartItemQuantity(userId,prodId)
      

      /* if (item.quantity === 1) {
        item.quantity = 1;
      } else {
        item.quantity--;
      } */
    },
    addUser: (state, action) => {
      state.userInfo = action.payload;
    },
    removeUser: (state, action) => {
      state.userInfo = null;
    },
    searchFilter: (state, action) => {
      state.query = action.payload;
    },
      searchToggle: (state,action) => {
        state.toggleOn = action.payload?action.payload:false;
    },
      viewProduct: (state, action) => {
        state.prodDetails = action.payload;
      },
      adminSidebarToggle: (state, action) => {
        state.toggleSidebar = action.payload;
      }
  },
});

export const {
  addToCart,
  deleteItem,
  resetCart,
  increaseQty,
  decreaseQty,
  addUser,
  removeUser,
  searchFilter,
  searchToggle,
  viewProduct,
  adminSidebarToggle,
} = shopSlice.actions;
export default shopSlice.reducer;
